import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphPersona } from "./personaAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  weeks: [],
  nudgeShown: [],
  nudgeAddToCart: [],
  nudgeBought: [],
  addToCartPerc: [],
  boughtPerc: [],
  shownToBoughtPerc: [],
  totalNudgeShown: 0,
  totalNudgeShownAndAddtoCart: 0,
  totalNudgeShownAndBought: 0  
};

export const graphPersona = createAsyncThunk(
  "persona/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-persona`;
      const response = await fetchGraphPersona(dbpath, user, "graph-persona");
      console.log("🔥 Redux: Persona data fetched for user:", user, response.data);
      
      return { data: response.data, user };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const personaSlice = createSlice({
  name: "persona",
  initialState,
  reducers: {
    resetpersonaSlice: (state, action) => {
      return { ...initialState };
    },
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphPersona.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphPersona.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        // const result = action.payload;
        const { data: result, user } = action.payload;
        // console.log(result);
        try {
          state.data = result;
          state.weeks = result[1]
          if (result[0].length >= 3) {
            state.nudgeShown = result[0][0]['data'];
            state.nudgeAddToCart = result[0][1]['data'];
            state.nudgeBought = result[0][2]['data'];
            state.addToCartPerc = getPercentage(result[0][0]['data'], result[0][1]['data'])
            state.boughtPerc = getPercentage(result[0][1]['data'], result[0][2]['data'])
            state.shownToBoughtPerc = getPercentage(result[0][0]['data'], result[0][2]['data'])
            if (user.includes("bodyglovehawaii")) {
              let index = result[1].indexOf("2024/10/14")
              console.log("bodyglovehawaii -- index", index)
              if (index !== -1) {
                // Use the elements after the index, so the range starts from index + 1.
                state.totalNudgeShown = result[0][0]['data'].slice(index + 1).reduce((a, b) => a + b, 0);
                state.totalNudgeShownAndAddtoCart = result[0][1]['data'].slice(index + 1).reduce((a, b) => a + b, 0);
                state.totalNudgeShownAndBought = result[0][2]['data'].slice(index + 1).reduce((a, b) => a + b, 0);
              }
            } else {
              state.totalNudgeShown = result[0][0]['data'].reduce((a, b) => a + b, 0);
              state.totalNudgeShownAndAddtoCart = result[0][1]['data'].reduce((a, b) => a + b, 0);
              state.totalNudgeShownAndBought = result[0][2]['data'].reduce((a, b) => a + b, 0);
            }
          }
        } catch (error) {
          // console.warn("Persona data not found!", error)
        }

      })
      .addCase(graphPersona.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const {resetpersonaSlice} = personaSlice.actions;


export const SelectNudgeShown = (state) => state.persona.nudgeShown;
export const SelectNudgeAddToCart = (state) => state.persona.nudgeAddToCart;
export const SelectNudgeBought = (state) => state.persona.nudgeBought;
export const SelectAddToCartPerc = (state) => state.persona.addToCartPerc;
export const SelectBoughtPerc = (state) => state.persona.boughtPerc;
export const SelectShownToBoughtPerc = (state) => state.persona.shownToBoughtPerc;


export const SelectAllTimeNudgeShown = (state) => state.persona.totalNudgeShown;
export const SelectAllTimeNudgeAddedToCart = (state) => state.persona.totalNudgeShownAndAddtoCart;
export const SelectAllTimeNudgeBought = (state) => state.persona.totalNudgeShownAndBought;
export const SelectWeeks = (state) => state.persona.weeks;
export const SelectPersonaStatus = (state) => state.persona.status;


export default personaSlice.reducer;

function getPercentage(total, obtained) {
    let percentages = []
    for(let i=0; i<total.length; i++){
        percentages[i] = Math.round((obtained[i]*100/total[i])*100)/100
    }
    return percentages;
  }